import { useEffect, useState } from "react";
import { Table, Button, Modal, Form, Input, Select, message } from "antd";
import { 
  getAllTags, 
  addTag, 
  updateTag, 
  deleteTag,
  getAllTagTypes 
} from "../services/tagService";
import { toast } from 'react-toastify';

const Tags = () => {
  const [tags, setTags] = useState([]);
  const [tagTypes, setTagTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [editingTag, setEditingTag] = useState(null);
  const [deletingTag, setDeletingTag] = useState(null);
  const [form] = Form.useForm();

  const fetchTags = async () => {
    setLoading(true);
    try {
      const response = await getAllTags();
      setTags(response.Data.Items || []);
    } catch {
      message.error("Etiketler alınamadı.");
    } finally {
      setLoading(false);
    }
  };

  const fetchTagTypes = async () => {
    try {
      const response = await getAllTagTypes();
      setTagTypes(response.Data.Items || []);
    } catch {
      message.error("Etiket tipleri alınamadı.");
    }
  };

  const handleAddOrUpdate = async (values) => {
    try {
      let response;
      if (editingTag) {
        response = await updateTag({ ...editingTag, ...values });
      } else {
        response = await addTag(values);
      }

      if (response?.Status) {
        toast.success(response?.Message || response?.MessageCode || "İşlem başarılı.");
      } else {
        toast.error(response?.Message || "İşlem başarısız.");
      }

      fetchTags();
      setIsModalOpen(false);
      form.resetFields();
      setEditingTag(null);
    } catch (error) {
      const msg = error?.response?.data?.Message || "İşlem sırasında hata oluştu.";
      toast.error(msg);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await deleteTag(id);
      if (response?.Status) {
        toast.success(response?.Message || response?.MessageCode || "Silme işlemi başarılı.");
        fetchTags();
      } else {
        toast.error(response?.Message || "Silme işlemi başarısız.");
      }
    } catch (error) {
      const msg = error?.response?.data?.Message || "Silme sırasında hata oluştu.";
      toast.error(msg);
    } finally {
      setIsDeleteModalOpen(false);
      setDeletingTag(null);
    }
  };

  useEffect(() => {
    fetchTags();
    fetchTagTypes();
  }, []);

  const getTagTypeName = (tagTypeId) => {
    const tagType = tagTypes.find(type => type.id === tagTypeId);
    return tagType?.name || '-';
  };

  return (
    <div>
      <h2>Etiketler</h2>
      <Button type="primary" onClick={() => setIsModalOpen(true)} style={{ marginBottom: 16 }}>
        Yeni Etiket Ekle
      </Button>
      <Table
        rowKey="id"
        loading={loading}
        dataSource={tags}
        columns={[
          { title: "Ad", dataIndex: "name" },
          { 
            title: "Etiket Tipi", 
            dataIndex: "tagTypeId",
            render: (tagTypeId) => getTagTypeName(tagTypeId)
          },
          { title: "Açıklama", dataIndex: "description" },
          {
            title: "İşlem",
            width: 200,
            render: (text, record) => (
              <>
                <Button
                  onClick={() => {
                    setEditingTag(record);
                    form.setFieldsValue(record);
                    setIsModalOpen(true);
                  }}
                  style={{ marginRight: 8 }}
                >
                  Güncelle
                </Button>
                <Button
                  danger
                  onClick={() => {
                    setDeletingTag(record);
                    setIsDeleteModalOpen(true);
                  }}
                >
                  Sil
                </Button>
              </>
            ),
          },
        ]}
      />

      {/* Ekle / Güncelle Modal */}
      <Modal
        title={editingTag ? "Etiket Güncelle" : "Etiket Ekle"}
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setEditingTag(null);
          form.resetFields();
        }}
        onOk={() => form.submit()}
      >
        <Form form={form} onFinish={handleAddOrUpdate} layout="vertical">
          <Form.Item 
            name="name" 
            label="Etiket Adı" 
            rules={[{ required: true, message: "Etiket adı gereklidir!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item 
            name="tagTypeId" 
            label="Etiket Tipi" 
            rules={[{ required: true, message: "Etiket tipi seçiniz!" }]}
          >
            <Select placeholder="Etiket tipi seçiniz">
              {tagTypes.map(type => (
                <Select.Option key={type.id} value={type.id}>
                  {type.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="description" label="Açıklama">
            <Input.TextArea rows={3} />
          </Form.Item>
        </Form>
      </Modal>

      {/* Silme Onay Modalı */}
      <Modal
        title="Silme işlemini onaylıyor musunuz?"
        open={isDeleteModalOpen}
        onCancel={() => {
          setIsDeleteModalOpen(false);
          setDeletingTag(null);
        }}
        onOk={() => {
          if (deletingTag) {
            handleDelete(deletingTag.id);
          }
        }}
        okText="Evet, Sil"
        okType="danger"
        cancelText="Vazgeç"
      >
        <p>
          "{deletingTag?.name}" adlı etiket silinecek. Bu işlemi onaylıyor musunuz?
        </p>
      </Modal>
    </div>
  );
};

export default Tags;